// extracted by mini-css-extract-plugin
module.exports = {"container":"discover-DiscoverFooter__container--2FZAq","btn":"discover-DiscoverFooter__btn--3h5dZ"};